import React, { PureComponent } from "react";

export default class CG extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#d80027"
          />
          <path d="M443.726,85.331,102.4,426.657H0V85.331Z" fill="#6da544" />
          <path
            d="M500.124,85.331,158.8,426.657H11.876L353.2,85.331Z"
            fill="#ffda44"
          />
        </g>
      </svg>
    );
  }
}
